import { useLayout } from '@/hooks/useLayout';
import { useContentScale } from './useContentScale';

const SIDEBAR_WIDTH_COLLAPSED = 80;
const SIDEBAR_WIDTH_EXPANDED = 256;

export const PageContentRoot = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { sidebarCollapsed } = useLayout();
  const scaleStyle = useContentScale(
    sidebarCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED
  );

  return (
    <div
      className={`w-auto flex flex-col box-border min-h-screen transition-all ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}
    >
      <div className="flex flex-col flex-1 min-h-screen" style={scaleStyle}>
        {children}
      </div>
    </div>
  );
};
